import _lib from '../_lib';
import active from './active/index';
import {UserContactNavigation} from '@/store/modules/fsm/messages';

export default ({tree,parent,api}) => {
  let regionName = 'contact';
  let activations = [
    {
      name: 'contact',
      test: api.messageIs(UserContactNavigation)
    }
  ];
  let activeIndex = active;
  let func = _lib({regionName,activations,activeIndex});
  return func({tree,parent,api});
};

